import { useState } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { StyledAdminAddPoolConfigForm } from './styles';
import { Input } from 'components';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrow-down-full.svg';

export interface IPoolConfigDraft {
  name: string;
  host: string;
  port: string;
  algorithm: string;
  user: string;
  password: string;
}

interface IAdminAddPoolConfigFormProps {
  config: IPoolConfigDraft;
  onChange: (updated: IPoolConfigDraft) => void;
}

const algorithmOptions = [
  { value: 'SCRYPT', label: 'SCRYPT' },
  { value: 'BOOST', label: 'BOOST' },
];

export const AdminAddPoolConfigForm = ({ config, onChange }: IAdminAddPoolConfigFormProps) => {
  const { t } = useTranslation();
  const [isDropdownCollapsed, setIsDropdownCollapsed] = useState(true);

  const handleChange =
    (field: keyof IPoolConfigDraft) => (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange({ ...config, [field]: e.target.value });
    };

  const handleAlgorithmSelect = (value: string) => {
    onChange({ ...config, algorithm: value });
    setIsDropdownCollapsed(true);
  };

  const selectedAlgorithmLabel =
    algorithmOptions.find((opt) => opt.value === config.algorithm)?.label || '---';

  return (
    <StyledAdminAddPoolConfigForm>
      <Input
        placeholder={t('adminPage.editPoolConfigs.listHeaders.name')}
        value={config.name}
        onChange={handleChange('name')}
      />

      <Input
        placeholder={t('adminPage.editPoolConfigs.listHeaders.host')}
        value={config.host}
        onChange={handleChange('host')}
      />

      <Input
        placeholder={t('adminPage.editPoolConfigs.listHeaders.port')}
        value={config.port}
        onChange={handleChange('port')}
      />

      <div className="form-select-wrapper">
        <div className="selected-group" onClick={() => setIsDropdownCollapsed((prev) => !prev)}>
          <div className="selected-group-name">{selectedAlgorithmLabel}</div>
          <div className={cn('drop-down-arrow', isDropdownCollapsed && 'collapsed')}>
            <ArrowDownIcon />
          </div>
        </div>
        {!isDropdownCollapsed && (
          <div className="custom-dropdown" onMouseLeave={() => setIsDropdownCollapsed(true)}>
            {algorithmOptions
              .filter((opt) => opt.value !== config.algorithm)
              .map((opt) => (
                <div
                  key={opt.value}
                  className="dropdown-option"
                  onClick={() => handleAlgorithmSelect(opt.value)}
                >
                  {opt.label}
                </div>
              ))}
          </div>
        )}
      </div>

      <Input
        placeholder={t('adminPage.editPoolConfigs.listHeaders.user')}
        value={config.user}
        onChange={handleChange('user')}
      />

      <Input
        placeholder={t('adminPage.editPoolConfigs.listHeaders.password')}
        value={config.password}
        type="password"
        onChange={handleChange('password')}
      />
    </StyledAdminAddPoolConfigForm>
  );
};
